import { useQuery } from "@tanstack/react-query";
import { useSelectedPlanContext } from "../contexts/SelectedPlanContext";
import React from "react";

const fetchPlans = async ({ queryKey }) => {
	const [_key, service, location, currency, isQuickBuy] = queryKey;

	const quickBuyUrl = isQuickBuy ? "&quickbuy=1" : "";
	const response = await fetch(
		`${process.env.GATSBY_PLANS_ENDPOINT}` +
			`service=${service}&location=${location}&currency=${currency}` +
			quickBuyUrl +
			`&cycle=monthly`
	);

	if (!response.ok) throw new Error("Network response error");

	const data = await response.json();
	return data;
};

export const useFetchPlans = (selectedService, selectedLocation, selectedCurrency, isQuickBuy) => {
	const { changeSelectedPlan } = useSelectedPlanContext();

	const query = useQuery({
		queryKey: ["plans", selectedService, selectedLocation, selectedCurrency, isQuickBuy],
		queryFn: fetchPlans,
		refetchOnWindowFocus: false,
		enabled: !!selectedService && !!selectedLocation && !!selectedCurrency,
	});

	// Set default plan once data is fetched
	React.useEffect(() => {
		if (query.data?.length) {
			const defaultPlan = query.data.find((plan) => plan.default) || query.data[0];

			if (defaultPlan) {
				const updatedDefaultPlan = {
					...defaultPlan,
					cpu: defaultPlan.cpus?.find((cpu) => cpu.in_plan) || defaultPlan.cpus?.[0] || null,
					ram: defaultPlan.rams?.find((ram) => ram.in_plan) || defaultPlan.rams?.[0] || null,
					storage:
						defaultPlan.storages?.find((storage) => storage.in_plan) || defaultPlan.storages?.[0] || null,
					bandwidth:
						defaultPlan.bandwidths?.find((bandwidth) => bandwidth.in_plan) ||
						defaultPlan.bandwidths?.[0] ||
						null,
					transfer:
						defaultPlan.transfers?.find((transfer) => transfer.in_plan) ||
						defaultPlan.transfers?.[0] ||
						null,
				};

				// Check for required resources
				const requiredKeys = ["cpu", "ram", "storage", "bandwidth", "transfer"];
				const missingResource = requiredKeys.find((key) => !updatedDefaultPlan[key]);

				if (!missingResource) {
					// changeSelectedPlan((prev) => (prev?.id ? prev : updatedDefaultPlan));
					changeSelectedPlan(updatedDefaultPlan);
				} else {
					changeSelectedPlan({
						id: "",
						name: "",
						type: "",
						price: 0,
						cpu: null,
						cpus: [],
						ram: null,
						rams: [],
						storage: null,
						storages: [],
						bandwidth: null,
						bandwidths: [],
						transfer: null,
						transfers: [],
					});
				}
			}
		}
	}, [query.data]);

	return query;
};
